module.exports = __webpack_public_path__ + "static/media/ic-search-white-32.8358b3f5.svg";